import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    this.element.setAttribute("autocomplete", "none")

    const config = {
      valueField: "id",
      labelField: "text",
      searchField: ["id", "text"],
      selectOnTab: true,
      openOnFocus: true,
      placeholder: "Start typing to search for a question...",
      maxItems: 1,
      closeAfterSelect: true,
      load: this.loadOptions,
      render: {
        option: this.renderOption,
        item: this.renderItem
      }
    }

    new TomSelect(this.element, config)
  }

  renderItem(question, escape) {
    return `<div>${escape(question.id)} - ${escape(question.text)}</div>`
  }

  renderOption(question, escape) {
    return `
    <div>
      ${escape(question.id)} - ${escape(question.text)}
    </div> `
  }

  loadOptions(query, callback) {
    const url = `${this.input.dataset.url}?search=${encodeURIComponent(query)} `

    fetch(url)
      .then(response => response.json())
      .then(json => {
        callback(json)
      }).catch(() => {
        callback()
      })
  }
}


